export var isPremiumGallection = function (gallection) {
    return !!(gallection === null || gallection === void 0 ? void 0 : gallection.premiumFolderData);
};
export var getPremiumGallectionType = function (gallection) { var _a; return (_a = gallection === null || gallection === void 0 ? void 0 : gallection.premiumFolderData) === null || _a === void 0 ? void 0 : _a.type; };
//# sourceMappingURL=gallections.js.map